// @ts-nocheck

// -----------------------------
// CONFIGURACIÓN GLOBAL (fácil de modificar)
// Edita estas variables para cambiar comportamiento sin tocar el resto del código
const LENS_STEP_CONFIG = {
  // Dominio por defecto de la tienda (se usa como fallback)
  SHOP_DOMAIN: 'gf7q0f-ma.myshopify.com',

  // Tag que identifica productos de tipo 'lens'
  TAG_LENS_TYPE: 'lens-type',

  // Número máximo de productos a recuperar desde la API de products.json
  PRODUCTS_LIMIT: 250,

  // Orden preferido para renderizar opciones
  PREFERRED_ORDER: ['progressive', 'monofocal', 'reading', 'single'],

  // Permitir selección múltiple en el step (true = multi-select, false = single-select)
  MULTI_SELECT: false,

  // Si true, usar getBasicLensTypes() cuando no se encuentren productos o mapping
  USE_BASIC_FALLBACK: true,
  // Controla si las opciones deben mostrar imagen de producto cuando esté disponible
  MOSTRAR_IMAGENES_PRODUCTO: true
};

// También puedes forzar el dominio desde la consola antes de cargar scripts:
// window.__AINY_SHOP_DOMAIN = 'mi-tienda.myshopify.com'
// o desde el configurador: this.configurator.shopDomain = 'mi-tienda.myshopify.com'
// -----------------------------
/**
 * Step específico: Tipo de Cristal
 */
class LensTypeStep extends LensConfiguratorStep {
  constructor(configurator, options = {}) {
    super(configurator, {
      ...options,
      stepKey: 'lens-type',
      title: 'Tipo de Cristal',
      description: 'Selecciona el tipo de cristal'
    });
    
    // No cargar automáticamente aquí: la inicialización asíncrona se hará
    // desde el configurador principal cuando el step sea visible (init()).
  }

  // Inicializador público para cargar configuración asíncrona bajo demanda
  async init() {
    if (typeof this.loadConfiguration === 'function') {
      await this.loadConfiguration();
    }
  }

  /**
   * Obtiene la URL correcta para las peticiones a Shopify
   */
  getShopifySearchUrl() {
    // Mantener compatibilidad: si se llama sin parámetros devuelve la URL base
    const shopDomain = this.getShopifyDomain();
    // Si el shopDomain coincide con el host actual, usar ruta relativa para evitar CORS
    const sameHost = (typeof window !== 'undefined' && window.location && window.location.host === shopDomain);
    const base = sameHost ? '' : `https://${shopDomain}`;
    return `${base}/products.json?limit=${LENS_STEP_CONFIG.PRODUCTS_LIMIT}`;
  }

  /**
   * Detecta el dominio de la tienda Shopify de forma más robusta
   */
  getShopifyDomain() {
    // Permitir forzar el dominio desde la configuración del configurador
    // (por ejemplo: this.configurator.shopDomain = 'mi-tienda.myshopify.com')
    if (this.configurator && this.configurator.shopDomain) {
      return this.configurator.shopDomain;
    }

    // Permitir forzar el dominio desde una variable global (útil para debug)
    if (window.__AINY_SHOP_DOMAIN) {
      return window.__AINY_SHOP_DOMAIN;
    }

    // Método 1: Buscar en window.Shopify (más confiable)
    if (window.Shopify && window.Shopify.shop) {
      return `${window.Shopify.shop}`;
    }
    
    // Método 2: Buscar en meta tags de Shopify
    const shopifyMeta = document.querySelector('meta[name="shopify-digital-wallet"]');
    if (shopifyMeta && shopifyMeta.content) {
      const match = shopifyMeta.content.match(/([^.]+\.myshopify\.com)/);
      if (match) return match[1];
    }

    // Fallback: preferir el host actual (si existe) para evitar CORS cuando el script
    // se ejecuta desde la misma tienda; si no está disponible, usar el valor configurado.
    if (typeof window !== 'undefined' && window.location && window.location.host) {
      return window.location.host;
    }

    return LENS_STEP_CONFIG.SHOP_DOMAIN || 'gf7q0f-ma.myshopify.com';
  }

  /**
   * Intenta detectar el locale/idioma actual de la tienda.
   * - Prefiere configuraciones explícitas en el configurador o window.Shopify.locale
   * - Luego busca el atributo lang del <html>
   * - Devuelve null si no se detecta
   */
  getCurrentLocale() {
    if (this.configurator && this.configurator.locale) return this.configurator.locale;
    if (window.Shopify && window.Shopify.locale) return window.Shopify.locale;
    const htmlLang = document.documentElement && document.documentElement.lang;
    if (htmlLang) return htmlLang.split('-')[0];
    const ogLocale = document.querySelector('meta[property="og:locale"]');
    if (ogLocale && ogLocale.content) return ogLocale.content;
    return null;
  }

  /**
   * Construye la URL para products.json incluyendo el locale detectado
   * Si se pasa `query` debe ser una cadena que comience por '?' (ej. '?q=tag:lens-type')
   */
  buildShopifyProductsUrl(query) {
    const shopDomain = this.getShopifyDomain();
    const locale = this.getCurrentLocale();
    // Usar ruta relativa si el dominio coincide con el host actual (evita CORS)
    const sameHost = (typeof window !== 'undefined' && window.location && window.location.host === shopDomain);
    const base = sameHost ? '' : `https://${shopDomain}`;
    let url = `${base}/products.json?limit=${LENS_STEP_CONFIG.PRODUCTS_LIMIT}`;
    if (query && typeof query === 'string') {
      const q = query.replace(/^\?/, '');
      if (q) url += `&${q}`;
    }
    if (locale) {
      url += `&locale=${encodeURIComponent(locale)}`;
    }
    return url;
  }

  async loadConfiguration() {
    if (!this.configurator.config) {
      this.configurator.config = {};
    }
    
    this.configurator.config.lensTypes = await this.loadLensTypesFromShopify();

    // Forzar re-render cuando la configuración asíncrona termine.
    // render() verificará la presencia del contenedor y usará el fallback si es necesario.
    try {
      this.render();
    } catch (e) {
      console.warn('⚠️ Error al re-renderizar LensTypeStep tras cargar config:', e);
    }
  }

  /**
   * Carga los tipos de cristal dinámicamente desde productos de Shopify
   */
  async loadLensTypesFromShopify() {
    try {

      let lensProducts = [];
      if (window.LensStepUtils && typeof window.LensStepUtils.fetchProductsByTag === 'function') {
        lensProducts = await window.LensStepUtils.fetchProductsByTag(this.configurator, LENS_STEP_CONFIG.TAG_LENS_TYPE, LENS_STEP_CONFIG.PRODUCTS_LIMIT);
        console.log('👓 Productos (via LensStepUtils) con tag lens-type:', lensProducts);
      } else {
        // Fallback: fetch directo a products.json y filtrar
        const productsUrl = this.getShopifySearchUrl();
        console.log('🔍 (fallback) Consultando productos de Shopify:', productsUrl);
        const response = await fetch(productsUrl);
        if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        const data = await response.json();
        const allProducts = data.products || [];
        lensProducts = allProducts.filter(p => p.tags && p.tags.includes(LENS_STEP_CONFIG.TAG_LENS_TYPE));
        console.log('👓 (fallback) Productos con tag lens-type:', lensProducts);
      }

      if (lensProducts.length === 0) {
        console.warn('⚠️ No se encontraron productos con tag "lens-type"');
        return this.getBasicLensTypes();
      }

      const lensTypes = {};
      lensProducts.forEach(product => {
        const lensTypeKey = this.mapProductToLensTypeKey(product);
        if (lensTypeKey) {
          lensTypes[lensTypeKey] = {
            name: product.title,
            description: this.extractProductDescription(product),
            price: window.LensStepUtils.parsePrice(product),
            productId: product.id,
            handle: product.handle,
            image: product.images && product.images.length > 0 ? product.images[0].src : null,
            variants: product.variants
          };
          console.log(`✅ Mapeado: ${product.title} -> ${lensTypeKey}`);
        } else {
          console.warn(`❌ No se pudo mapear: ${product.title} (handle: ${product.handle})`);
        }
      });

      if (Object.keys(lensTypes).length === 0) {
        console.warn('⚠️ No se pudieron mapear productos a tipos de cristal');
        return this.getBasicLensTypes();
      }

      console.log('✅ Tipos de cristal cargados desde Shopify:', lensTypes);
      return lensTypes;
    } catch (error) {
      console.error('❌ Error cargando tipos de cristal desde Shopify:', error);
      return this.getBasicLensTypes();
    }
  }

  /**
   * Parsea el precio del producto (maneja diferentes formatos)
   */
  parsePrice(product) {
    if (!product.variants || product.variants.length === 0) return 0;
    
    // Tomar el precio de la primera variante
    const variant = product.variants[0];
    if (variant.price) {
      // Shopify devuelve precios como string en unidades (ej. "55.00").
      // Parsear directamente a número (no dividir entre 100).
      return parseFloat(variant.price);
    }
    return 0;
  }

  /**
   * Mapea el producto a la key correspondiente del tipo de cristal
   */
  mapProductToLensTypeKey(product) {
    const handle = product.handle.toLowerCase();
    const title = product.title.toLowerCase();

    console.log(`🔍 Mapeando producto: "${product.title}" (handle: "${handle}")`);

    // Mapeo basado en handle y título
    if (handle.includes('lectura') || title.includes('lectura')) {
      return 'reading';
    }
    if (handle.includes('sin-graduar') || handle.includes('sin graduar') || title.includes('sin graduar')) {
      return 'single';
    }
    if (handle.includes('monofocal') || title.includes('monofocal')) {
      return 'monofocal';
    }
    if (handle.includes('progresiv') || title.includes('progresiv') || 
        title.includes('cristales progresivos')) {
      return 'progressive';
    }

    // Fallback: buscar en tags
    if (product.tags) {
      const tags = product.tags.toLowerCase();
      if (tags.includes('reading') || tags.includes('lectura')) return 'reading';
      if (tags.includes('single') || tags.includes('sin-graduar')) return 'single';
      if (tags.includes('monofocal')) return 'monofocal';
      if (tags.includes('progressive') || tags.includes('progresivo')) return 'progressive';
    }

    console.warn('⚠️ No se pudo mapear el producto:', product.handle, product.title, product.tags);
    return null;
  }

  /**
   * Extrae la descripción del producto
   */
  extractProductDescription(product) {
    if (product.body_html) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = product.body_html;
      const text = tempDiv.textContent || tempDiv.innerText || '';
      // Limpiar espacios y saltos de línea
      const cleanText = text.replace(/\s+/g, ' ').trim();
      return cleanText.length > 150 ? cleanText.substring(0, 150) + '...' : cleanText;
    }
    return 'Sin descripción disponible';
  }

  /**
   * Valores básicos por defecto para tipos de cristal
   */
  getBasicLensTypes() {
    console.warn('⚠️ Usando configuración básica por defecto');
    
    return {
      single: { 
        name: 'Sin Graduar', 
        price: 0, 
        description: 'Cristales básicos sin graduación.',
        isDefault: true
      },
      monofocal: { 
        name: 'Monofocales', 
        price: 25, 
        description: 'Para una sola distancia de enfoque.',
        isDefault: false
      },
      progressive: { 
        name: 'Progresivos', 
        price: 55, 
        description: 'Para todas las distancias sin líneas visibles.',
        isDefault: false
      },
      reading: { 
        name: 'De Lectura', 
        price: 15, 
        description: 'Específicamente para leer y trabajos de cerca.',
        isDefault: false
      }
    };
  }

  /**
   * Muestra un mensaje de error en el contenedor
   */
  showError(message) {
    const container = document.getElementById('lens-type-options');
    if (!container) return;
    
    container.innerHTML = `
      <div class="error-message" style="
        background: #fee;
        border: 1px solid #fcc;
        color: #c33;
        padding: 15px;
        border-radius: 5px;
        text-align: center;
        margin: 20px 0;
      ">
        <strong>Error:</strong> ${message}
        <br><br>
        <small>Usando configuración temporal. Contacte al administrador.</small>
      </div>
    `;
  }

  shouldSkip() {
    return false;
  }

  render() {
    const container = document.getElementById('lens-type-options');
    if (!container) {
      console.error('❌ No se encontró el contenedor lens-type-options');
      return;
    }
    if (!this.configurator.config?.lensTypes || Object.keys(this.configurator.config.lensTypes).length === 0) {
      // No mostrar error en la UI: usar fallback básico y continuar el render.
      console.warn('⚠️ Tipos de cristal no cargados dinámicamente — usando configuración básica por defecto.');
      this.configurator.config = this.configurator.config || {};
      this.configurator.config.lensTypes = this.getBasicLensTypes();
    }
    
    container.innerHTML = '';

  // Orden deseado para mostrar los tipos de cristal
  const preferredOrder = LENS_STEP_CONFIG.PREFERRED_ORDER || ['progressive', 'monofocal', 'reading', 'single'];
    const lensMap = this.configurator.config.lensTypes || {};

    // Añadir en el orden preferido si existen
    const isMultiple = Boolean(LENS_STEP_CONFIG.MULTI_SELECT);
    container.dataset.multiple = isMultiple.toString();

    preferredOrder.forEach(key => {
      if (lensMap[key]) {
        const card = this.createOptionCard(key, lensMap[key], 'lensType', isMultiple);

        // Si la opción es 'reading' añadimos el panel de graduación (magnification)
        // y prevenimos el avance automático hasta que el usuario seleccione una magnificación.
        if (key === 'reading') {
          try {
            card.dataset.preventAutoAdvance = 'true';

            try {
              // Usar helper que construye el panel de graduación de lectura
              const wrapper = this.createReadingGraduationWrapper(card);
              card.appendChild(wrapper);
            } catch (e) {
              console.warn('Error al crear panel de graduación para lectura', e);
            }
          } catch (e) {
            console.warn('Error al crear panel de graduación para lectura', e);
          }
        }

        container.appendChild(card);
      }
    });

    // Añadir cualquier otro tipo que no esté en preferredOrder
    Object.entries(lensMap).forEach(([key, lensType]) => {
      if (!preferredOrder.includes(key)) {
        const card = this.createOptionCard(key, lensType, 'lensType', isMultiple);
        container.appendChild(card);
      }
    });

    

    console.log('🎨 Renderizados tipos de cristal:', this.configurator.config.lensTypes);
  }

  /**
   * Crea un selector vertical de colores fotocromáticos.
   * Retorna un nodo DOM completamente funcional que gestiona selección y restore.
   */
  

  /**
   * Crea y devuelve el wrapper DOM con la tabla de graduaciones de lectura.
   * Centraliza la lista de valores para facilitar su edición.
   */
  createReadingGraduationWrapper(card) {
    // Valores organizados por filas para facilitar edición
    const magnificationRows = [
      ['+1.00', '+1.50', '+2.00', '+2.50'],
      ['+3.00']
    ];

    // Contenedor principal
    const wrapper = document.createElement('div');
    wrapper.className = 'reading-graduation-wrapper';

    // Cabecera explicativa
    const header = document.createElement('div');
    header.className = 'wiz-form__step-heading';
    header.innerHTML = '<p class="step-heading__title heading-font">Graduación</p>' +
                       '<p class="step-heading__description body-font padding-x-lg">Selecciona las dioptrías de tus gafas de lectura</p>';
    wrapper.appendChild(header);

    // Tabla (grid) de opciones
    const table = document.createElement('div');
    table.className = 'ce-table-reading margin-top-lg ce-option__nobasic';
    table.dataset.optionValue = 'option1';
    table.dataset.optionType = 'reading-values';

    // Crear filas y celdas
    magnificationRows.forEach(rowVals => {
      const row = document.createElement('div');
      row.className = 'ce-table-row-reading';
      rowVals.forEach(val => {
        const cell = document.createElement('div');
        cell.className = 'ce-table-cell-reading';
        cell.setAttribute('role', 'button');
        cell.setAttribute('tabindex', '0');
        cell.dataset.value = val;
        // Mostrar etiqueta sin el '+' y con formato simple
        const label = document.createElement('label');
        const num = parseFloat(val);
        label.textContent = Number.isFinite(num) ? (num % 1 === 0 ? String(num) : String(num)) : val.replace('+', '');
        cell.appendChild(label);
        row.appendChild(cell);
      });
      table.appendChild(row);
    });

    wrapper.appendChild(table);

    // Inicialmente oculto salvo si la tarjeta ya está seleccionada
    wrapper.style.display = card.classList.contains('selected') ? '' : 'none';

    // Función para manejar la selección de una magnificación
    const cells = wrapper.querySelectorAll('.ce-table-cell-reading');
    const selectMagnification = (cell) => {
      if (!cell) return;
      const val = cell.dataset.value;
      if (!val) return;

      if (!this.configurator.configuration) this.configurator.configuration = {};
      this.configurator.configuration.magnification = val;

      // Visual
      card.classList.add('selected');
      cells.forEach(c => c.classList.remove('selected'));
      cell.classList.add('selected');

      // Actualizar precio/estado en configurador
      try { this.configurator.calculatePrice(); } catch (e) {}
      try { this.configurator.updatePriceDisplay(); } catch (e) {}
      try { this.configurator.updateDrawerFooter(); } catch (e) {}

      // Avanzar automáticamente al paso de 'material' (si existe) o al siguiente
      setTimeout(() => {
        try {
          this.configurator.configuration.lensType = this.configurator.configuration.lensType || 'reading';
          const steps = Array.isArray(this.configurator.steps) ? this.configurator.steps : [];
          const targetKey = 'material';
          const targetIndex = steps.indexOf(targetKey);
          if (targetIndex !== -1 && typeof this.configurator.renderCurrentStep === 'function') {
            this.configurator._lastStepIndex = (typeof this.configurator._lastStepIndex === 'number') ? this.configurator._lastStepIndex : this.configurator.currentStep;
            this.configurator.currentStep = targetIndex;
            this.configurator.renderCurrentStep();
          } else {
            try { this.configurator.nextStep(); } catch (e) {}
          }
        } catch (e) {}
      }, 120);
    };

    // Event listeners en celdas (click y keyboard)
    cells.forEach(cell => {
      cell.addEventListener('click', (e) => {
        e.preventDefault();
        selectMagnification(cell);
      });
      cell.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectMagnification(cell);
        }
      });
    });

    // Toggle del panel al hacer click en la tarjeta (ignorando clicks en inputs/labels)
    card.addEventListener('click', (ev) => {
      const target = ev.target;
      if (target && (target.tagName === 'INPUT' || target.tagName === 'LABEL')) return;
      const panel = card.querySelector('.reading-graduation-wrapper');
      if (panel) panel.style.display = panel.style.display === 'none' ? '' : 'none';
    });

    // Restaurar selección previa si existe
    try {
      const cfg = this.configurator && this.configurator.configuration ? this.configurator.configuration : {};
      if (cfg.magnification) {
        card.classList.add('selected');
        wrapper.style.display = '';
        const matched = wrapper.querySelector(`.ce-table-cell-reading[data-value="${cfg.magnification}"]`);
        if (matched) {
          cells.forEach(c => c.classList.remove('selected'));
          matched.classList.add('selected');
        }
      } else {
        wrapper.style.display = 'none';
      }
    } catch (e) {}

    return wrapper;
  }

  /**
   * Override de canProceed: si el usuario seleccionó 'reading' exigimos
   * que haya seleccionado también una magnificación (graduación) antes de avanzar.
   */
  canProceed() {
    try {
      // Mantener comportamiento por defecto para pasos no requeridos
      if (!this.isRequired) return true;

      const cfg = this.configurator && this.configurator.configuration ? this.configurator.configuration : {};
      // Normalizar la key actual
      const currentLens = cfg.lensType || cfg.lens || null;

      if (currentLens === 'reading' || currentLens === 'lectura') {
        // Requerir magnification
        return Boolean(cfg.magnification);
      }

      // Caída al comportamiento por defecto de la clase base
      return super.canProceed ? super.canProceed() : true;
    } catch (e) {
      return true;
    }
  }
}

// Hacer disponible globalmente
window.LensTypeStep = LensTypeStep;